module.exports = __webpack_public_path__ + "img/seo.a448ac0c.svg";